import { State } from './types'

import { menu } from './mockData/menu.mock'
import { footerContent, footerText } from './mockData/footer.mock'
import { langLinks } from './mockData/lang.mock'
import { FooterContent } from '@globalonmedia/ui-components/dist/types/components/footer/footer.types'
import { Menu } from '@globalonmedia/ui-components/dist/types/components/header/menu.types'
import { LanguageItem } from '@globalonmedia/ui-components/dist/types/components/df-language-selector/lang.types'

declare global {
  interface Window {
    DFX: {
      i18n: {
        header: { menu: Menu; languages: LanguageItem[] }
        footer: { content: FooterContent; text: string }
      }
    }
  }
}

export const state: State = {
  menu: window?.DFX?.i18n?.header?.menu || menu,
  footerContent: window?.DFX?.i18n?.footer?.content || footerContent,
  footerText: window?.DFX?.i18n?.footer?.text || footerText,
  languages: window?.DFX?.i18n?.header?.languages || langLinks,
}
